import LinkButton from "~/components/LinkButton"

import { h1Style, imagePreview, h1Wrap, headerTextStyle } from "./article.css"
import { btnWrap } from "./index.css"

import { MetaFunction } from "@remix-run/node"
import TextBlock from "~/components/TextBlock"
import Footer from "~/components/Footer"
import { page } from "~/shared/styles.css"
import Logo from "~/components/Logo"
import StickyHeader from "~/components/StickyHeader"

export type PreviewImage = {
  url: string
  size: { w: number; h: number }
}

export type Url = { url: string; initial?: PreviewImage | null; loading?: boolean }

export const meta: MetaFunction = () => {
  return [
    { title: "Back Garden Ideas With Rescape AI | Generative Creativity" },
    {
      name: "description",
      content:
        "Discover new ideas, techniques and styles for your back garden with AI. Upload a photo of your garden and realise it's potential with endless choice.",
    },
    {
      property: "og:title",
      content: "Rescape AI - Easy back garden ideas.",
    },
    {
      property: "og:image",
      content: "https://rescapeai.com/styles/urban.webp",
    },
    {
      property: "og:description",
      content:
        "Discover new ideas, techniques and styles for your back garden with AI in the morden age.",
    },
    {
      tagName: "link",
      rel: "canonical",
      href: "https://rescapeai.com/article/back-garden-ideas",
    },
    {
      "script:ld+json": {
        "@context": "https://schema.org",
        "@type": "Article",
        headline: "Back Garden Ideas With Rescape AI | Generative Creativity",
        description:
          "Discover new ideas, techniques and styles for your back garden with AI. Upload a photo of your garden and realise it's potential with endless choice.",
        author: {
          "@type": "Organization",
          name: "Rescape AI",
        },
        datePublished: "2024-01-18",
        dateModified: "2024-01-18",
        publisher: {
          "@type": "Organization",
          name: "Rescape AI",
          logo: {
            "@type": "ImageObject",
            url: "https://rescapeai.com/logo.webp",
          },
        },
        image: "https://rescapeai.com/landing/modern-garden.webp",
        mainEntityOfPage: {
          "@type": "WebPage",
          "@id": "https://rescapeai.com/article/back-garden-ideas",
        },
        articleSection: [
          "Gardening",
          "Garden Ideas",
          "Artificial Intelligence",
          "Technology",
        ],
      },
    },
  ]
}

function Index() {
  return (
    <>
      <div
        className={h1Style}
        style={{
          textAlign: "center",
          backgroundImage: "url(/landing/modern-garden.webp)",
        }}
      >
        <div className={h1Wrap}>
          <Logo width="108px" />
          <h1 className={headerTextStyle}>Back garden ideas in the modern age</h1>
        </div>
      </div>
      <StickyHeader status="SignUp" />
      <div className={page}>
        <TextBlock
          title="Find serenity in your back garden"
          paragraphs={[
            `In the hustle and bustle of everyday life, your back garden can serve as a
        sanctuary, a place to unwind and connect with nature. If you're looking for
        inspiration to transform your garden with ai, you've come to the right place. Our
        generative AI garden design app is here to provide you with innovative and
        personalized back garden ideas that will breathe new life into your surroundings.`,
          ]}
          marginTop="4rem"
        />
        <img
          src="/marketing/cottage-charm-garden.webp"
          alt="A rustic and charming overgrown garden creates a magical atmopsphere of exploration and oneness with nature, one of the many back garden ideas generated with Rescape AI."
          className={imagePreview}
          style={{ marginTop: "4rem" }}
          loading="lazy"
        />
        <div className={btnWrap} style={{ marginTop: `${3}rem` }}>
          <LinkButton url="/ai-garden-design" shouldPrefetch>
            About AI garden design
          </LinkButton>
        </div>
        <TextBlock
          title="Generate beautiful garden designs"
          paragraphs={[
            `One of the key features of our AI garden generator is its ability to create
        personalized designs based on your preferences. Whether you prefer a lush green
        oasis, a contemporary outdoor space, or a cottage garden feel, our AI can generate
        ideas that align with your vision. Simply input your preferences, and watch as the
        generator creates a unique back garden design tailored just for you.`,
            `Beyond aesthetics, our AI garden generator can help you design functional outdoor
        spaces. From cozy seating areas to practical storage solutions, the generator
        considers the way you want to use your back garden. It's not just about creating a
        beautiful space; it's about making your outdoor area an extension of your home,
        perfect for entertaining guests or enjoying quiet moments alone.`,
          ]}
          marginTop="4rem"
        />
        <div className={btnWrap} style={{ marginTop: `${3}rem` }}>
          <LinkButton url="/ai-yard-design" shouldPrefetch>
            AI yard design
          </LinkButton>
        </div>
        <TextBlock
          title="Affordable AI Garden generator"
          paragraphs={[
            `Transforming your back garden into a haven of beauty and tranquility is now easier
        than ever with the help of our garden design app. By embracing innovative back
        garden ideas tailored to your preferences, you can create an outdoor space that
        reflects your personality and enhances your overall well-being. Say goodbye to the
        ordinary, and let our AI guide you towards a garden that is as unique as you are.`,
          ]}
          marginTop="4rem"
        />
        <div className={btnWrap} style={{ marginTop: `${3}rem` }}>
          <LinkButton
            url="/article/contemporary-garden-ideas-with-rescape-ai"
            shouldPrefetch
          >
            How it works
          </LinkButton>
        </div>
        <Footer />
      </div>
    </>
  )
}

export default Index
